export const BACKDROP = 'backdrop'
export const BUBBLE = 'bubble'
export const CARDBOARD = 'cardboard'
export const CUTOUT = 'cutout'
export const DOOR = 'door'
export const FIXTURE = 'fixture'
export const FLAT = 'flat'
export const FURNITURE = 'furniture'
export const PANEL = 'panel'
export const PUPPET = 'puppet'

export const ORDERED_THINGS = [
    BACKDROP,
    FLAT,
    DOOR,
    CUTOUT,
    PANEL,
    FURNITURE,
    FIXTURE,
    PUPPET,
    BUBBLE,
    CARDBOARD,
]
